import { IFilter } from "./IFilter";
import {Excursion} from "@/services/excursions/types";
import {ExcursionFilter, ExcursionFilterValue} from "@/services/filters/types";

export default class SelectFilter extends IFilter {
    private type = "select";
    public values: ExcursionFilterValue[];
    public checked: string[];
    public successes: {[key:string]: number};

    to_string(): string {
        return this.checked.join(',');
    }

    from_string(value: string) {
        this.checked = value.split(',');
    }

    changed(): boolean {
        return this.checked.length !== 0;
    }

    constructor(filter: ExcursionFilter) {
        super(filter.name,filter.code.toLocaleLowerCase());
        this.values = filter.values!;
        this.checked = [];
        this.successes = {};
    }

    toggleOption(option: ExcursionFilterValue){
        const index = this.checked.indexOf(option.name);
        if(index !== -1){
            this.checked.splice(index,1);
        }else{
            this.checked.push(option.name);
        }
    }

    checkOption(code: string){
        const option = this.values.find(option => option.code.toLocaleLowerCase() === code);
        if(option){
            this.toggleOption(option);
        }
    }

    optionChecked(option: ExcursionFilterValue){
        return this.checked.includes(option.name);
    }

    reset() {
        this.checked = [];
    }

    initialize(): boolean {
        return true;
    }

    test(excursion: Excursion): boolean {

        const value = excursion[this.key];

        if(this.checked.length !== 0 && !value){
            return false;
        }

        if(this.checked.length === 0 || this.checked.includes(value.toString())){
            if(value){
                this.addSuccess(value.toString());
            }
            return true;
        }

        return false;
    }

    public resetSuccesses(){
        this.successes = {};
    }

    private addSuccess(value: string){
        if(this.successes[value.toString()]){
            this.successes[value.toString()]++;
        }else{
            this.successes[value.toString()] = 1;
        }
    }
}